@if (appMembershipEntityDict$ | async; as appMembershipEntityDict) {
  @if (screeningAction(); as screeningAction) {
    <span>
      @if (screeningAction.removed_flag) {
        <span>
          <i class="fa fa-minus text-info me-2"></i>
          {{ 'tables.screening_suggestions_table.removed_from_screening' | translate }}
        </span>
      } @else {
        <span>
          <i class="fa fa-plus text-info me-2"></i>
          {{ 'tables.screening_suggestions_table.added_to_screening' | translate }}
        </span>
      }
      <br />
      @if (screeningAction.app_membership_uuid) {
        @let appMembershipEntityName =
          appMembershipEntityDict[screeningAction.app_membership_uuid]?.app_user_email || 'common.unknown' | translate;
        <code class="text-muted">
          @if (screeningAction.approved_flag) {
            <span innerHTML="{{ 'screening.log.approved_by' | translate: { name: appMembershipEntityName } }}"> </span>
          } @else {
            <span innerHTML="{{ 'screening.log.rejected_by' | translate: { name: appMembershipEntityName } }}"> </span>
          }
        </code>
      }
      @if (screeningAction.decision_comment) {
        <br /><code class="text-muted">
          {{ screeningAction.decision_comment }}
        </code>
      }
    </span>
  }
}
